// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportError-module__reportErrorContainer {
  display: flex;
  width: 552px;
  padding: 22px 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.ReportError-module__closeHeader {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.ReportError-module__closeBtn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.ReportError-module__reportErrorContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
}
.ReportError-module__reportErrorTitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.ReportError-module__reportErrorTitle h2 {
  color: #1e2a36;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 167%; /* 30.06px */
}
.ReportError-module__pageNumberSection {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}
.ReportError-module__pageNumberSection label {
  color: var(--Color-Dark-Grey-400, #324452);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
.ReportError-module__pageNumberInput {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #324452;
  background: #fff;
  padding: 0 14px;
}
.ReportError-module__pageNumberInput::placeholder {
  color: var(--Color-Dark-Grey-500, #263643);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  opacity: 0.3;
}
.ReportError-module__descriptionSection {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.ReportError-module__descriptionSection label {
  color: var(--Color-Dark-Grey-400, #324452);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
.ReportError-module__reasonList {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ReportError-module__reasonItem {
  border-radius: 5px;
  border: 1px solid #324452;
  background: #fff;
  width: 100%;
  height: 50px;
  list-style: none;
  display: flex;
  flex-direction: row;
  gap: 14px;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
}
.ReportError-module__reasonItem input[type="checkbox"] {
  width: 26px;
  height: 26px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #263643;
}
.ReportError-module__reasonItem label {
  color: #324452;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}
.ReportError-module__commentSection {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 497px;
}
.ReportError-module__commentHeader {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.ReportError-module__commentHeader label {
  color: var(--Color-Dark-Grey-400, #324452);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.ReportError-module__characterLimit {
  color: var(--Color-Dark-Grey-400, #324452);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  opacity: 0.5;
}
.ReportError-module__commentTextarea {
  width: 497px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #324452;
  background: #fff;
  box-sizing: border-box;
  padding: 0 14px;
  resize: none;
  color: #263643;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.ReportError-module__submitButtonSection {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.ReportError-module__cancelButton {
  display: flex;
  height: 50px;
  padding: 0px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  border-radius: 70px;
  border: 1px solid #263643;
  background-color: #fff;
  color: #263643;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  cursor: pointer;
}
.ReportError-module__submitButton {
  display: flex;
  height: 50px;
  padding: 0px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  border-radius: 56px;
  background: #263643;
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/modals/reporterror/ReportError.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;AACA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,mDAAmD;EACnD,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".reportErrorContainer {\n  display: flex;\n  width: 552px;\n  padding: 22px 24px;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n}\n\n.closeHeader {\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.reportErrorContent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n}\n.reportErrorTitle {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n}\n.reportErrorTitle h2 {\n  color: #1e2a36;\n  font-family: Montserrat;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 167%; /* 30.06px */\n}\n.pageNumberSection {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n}\n.pageNumberSection label {\n  color: var(--Color-Dark-Grey-400, #324452);\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%; /* 21px */\n}\n.pageNumberInput {\n  width: 100%;\n  height: 50px;\n  border-radius: 5px;\n  border: 1px solid #324452;\n  background: #fff;\n  padding: 0 14px;\n}\n.pageNumberInput::placeholder {\n  color: var(--Color-Dark-Grey-500, #263643);\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  opacity: 0.3;\n}\n.descriptionSection {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n}\n.descriptionSection label {\n  color: var(--Color-Dark-Grey-400, #324452);\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%; /* 21px */\n}\n.reasonList {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.reasonItem {\n  border-radius: 5px;\n  border: 1px solid #324452;\n  background: #fff;\n  width: 100%;\n  height: 50px;\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  gap: 14px;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0px 20px;\n}\n.reasonItem input[type=\"checkbox\"] {\n  width: 26px;\n  height: 26px;\n  margin: 0;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #263643;\n}\n.reasonItem label {\n  color: #324452;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%; /* 24px */\n}\n.commentSection {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 497px;\n}\n.commentHeader {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n.commentHeader label {\n  color: var(--Color-Dark-Grey-400, #324452);\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n.characterLimit {\n  color: var(--Color-Dark-Grey-400, #324452);\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  opacity: 0.5;\n}\n.commentTextarea {\n  width: 497px;\n  height: 50px;\n  border-radius: 5px;\n  border: 1px solid #324452;\n  background: #fff;\n  box-sizing: border-box;\n  padding: 0 14px;\n  resize: none;\n  color: #263643;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n.submitButtonSection {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.cancelButton {\n  display: flex;\n  height: 50px;\n  padding: 0px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  border-radius: 70px;\n  border: 1px solid #263643;\n  background-color: #fff;\n  color: #263643;\n  text-align: center;\n  font-variant-numeric: lining-nums proportional-nums;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.56px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n.submitButton {\n  display: flex;\n  height: 50px;\n  padding: 0px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  border-radius: 56px;\n  background: #263643;\n  color: #fff;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.56px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportErrorContainer": `ReportError-module__reportErrorContainer`,
	"closeHeader": `ReportError-module__closeHeader`,
	"closeBtn": `ReportError-module__closeBtn`,
	"reportErrorContent": `ReportError-module__reportErrorContent`,
	"reportErrorTitle": `ReportError-module__reportErrorTitle`,
	"pageNumberSection": `ReportError-module__pageNumberSection`,
	"pageNumberInput": `ReportError-module__pageNumberInput`,
	"descriptionSection": `ReportError-module__descriptionSection`,
	"reasonList": `ReportError-module__reasonList`,
	"reasonItem": `ReportError-module__reasonItem`,
	"commentSection": `ReportError-module__commentSection`,
	"commentHeader": `ReportError-module__commentHeader`,
	"characterLimit": `ReportError-module__characterLimit`,
	"commentTextarea": `ReportError-module__commentTextarea`,
	"submitButtonSection": `ReportError-module__submitButtonSection`,
	"cancelButton": `ReportError-module__cancelButton`,
	"submitButton": `ReportError-module__submitButton`
};
export default ___CSS_LOADER_EXPORT___;
